export const serviceProviderEditModalId = 'service-provider-edit-modal';
